
import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import MuiAppBar from '@material-ui/core/AppBar';

const styles = (theme: { palette: { common: { white: any } } }) => ({
  root: {
    color: theme.palette.common.white
  }
});

function AppBar(props: any) {
  return <MuiAppBar elevation={0} position="fixed" {...props} />;
}

export default withStyles(styles)(AppBar);


// WEBPACK FOOTER //
// ./src/components/header/AppBar.tsx